import React from 'react';
import { Button, ButtonProps, makeStyles } from '@smile-next/uikit';

type Props = ButtonProps;

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        height: 40,
        fontSize: 18,
    },
}));

export const LoginFormButton: React.FC<Props> = (props) => {
    const { onClick, children, disabled } = props;
    const classes = useStyles();

    return (
        <Button className={classes.root} disabled={disabled} fill variant="square" onClick={onClick}>
            {children}
        </Button>
    );
};
